function Thailand({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2290)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.0048 10.4346H0.995188C0.352 12.1679 0 14.0426 0 15.9998C0 17.9569 0.352 19.8316 0.995188 21.5649H31.0049C31.648 19.8316 32 17.9569 32 15.9998C32 14.0426 31.648 12.1679 31.0048 10.4346Z" fill="#0052B4"/>
  <path d="M16 0C11.1506 0 6.8054 2.15775 3.87122 5.56519H28.1288C25.1947 2.15775 20.8495 0 16 0Z" fill="#D80027"/>
  <path d="M28.1288 26.4346H3.87122C6.8054 29.842 11.1506 31.9998 16 31.9998C20.8495 31.9998 25.1947 29.842 28.1288 26.4346Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Thailand;
